// Constants
import { COMMON_API_ERROR } from '../../../constants/errors';

const flattenError = (value) => {
  if (Array.isArray(value)) {
    return value.filter(Boolean).join(' ');
  }
  if (typeof value === 'string') {
    return value;
  }
  return '';
};

const parseSharedKitError = (error) => {
  const data = error?.response?.data;

  if (!data) {
    return { detail: error?.message || COMMON_API_ERROR, fieldErrors: {} };
  }

  if (typeof data === 'string') {
    return { detail: data, fieldErrors: {} };
  }

  const fieldErrors = {};
  let detail = '';

  Object.entries(data).forEach(([field, value]) => {
    if (field === 'detail') {
      detail = flattenError(value);
      return;
    }
    if (field === 'unavailable_product_ids') {
      return;
    }

    const message = flattenError(value);
    if (message) {
      fieldErrors[field] = message;
    }
  });

  return {
    detail: detail || COMMON_API_ERROR,
    fieldErrors,
    unavailableProductIds: data.unavailable_product_ids || [],
  };
};

export { parseSharedKitError, flattenError };
